// extracted by mini-css-extract-plugin
module.exports = {"title":"Catalog_title__rgcN_","listContainer":"Catalog_listContainer__taRJJ","isMobile":"Catalog_isMobile__2_05_"};